module.exports = __webpack_public_path__ + "img/kda.f59ddc31.svg";